import { defineComponent, reactive } from 'vue';
import { PopupWrapper } from '@hems/component';
import UserInfo from '@hems/user/src/containers/popup/homeinfo/account/UserInfo.vue';
import Control from '@hems/user/src/containers/popup/homeinfo/control/Control.vue';
import InstallationInfo from '@hems/user/src/containers/popup/homeinfo/installation/InstallationInfo.vue';
import { useACDeviceType, useGenType } from '@hems/util';
export default defineComponent({
    name: 'HomeInfoPopup',
    components: {
        PopupWrapper,
        UserInfo,
        InstallationInfo,
        Control,
    },
    props: {
        tabName: {
            type: String,
            default: 'user',
        },
    },
    emits: ['close', 'withdrawal'],
    setup(props) {
        const state = reactive({
            tabName: props.tabName ?? 'user',
        });
        const { isACSystem } = useGenType();
        const { isSolarConfig } = useACDeviceType();
        function onClickTab(tabName) {
            state.tabName = tabName;
        }
        return {
            state,
            isACSystem,
            isSolarConfig,
            onClickTab,
        };
    },
});
